function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import { formatRut } from "../../helperComponents/InputRut/rutValidate";
import { FaEdit, FaEye } from "react-icons/fa";
import { colorStatus, colorCondition } from "./helper/polizaRenewalHelper";
import "./polizaRenewal.scss";
import * as moment from "moment";
import { fullName } from "../../helperComponents";
import TooltipButton from 'components/common/TooltipButton';

var ListPolizaRenewal = function ListPolizaRenewal(props) {
  var polizaRenewals = props.polizaRenewals,
      onSelectedPolizaRenewal = props.onSelectedPolizaRenewal; // Estado para el tooltip de scroll

  var _React$useState = React.useState({
    show: false,
    text: "",
    x: 0,
    y: 0
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      scrollTooltip = _React$useState2[0],
      setScrollTooltip = _React$useState2[1]; // Ref para la tabla y el contenedor scrollable


  var tableRef = React.useRef(null);
  var scrollRef = React.useRef(null); // Nombres de las columnas para el tooltip

  var columnNames = ["Propuesta", "Nº Póliza", "Estado", "Condición", "Compañía", "Asegurado", "Materia", "Inicio Vigencia", "Fin Vigencia", "Ramo", "Prima Neta", "Prima Renovación", "Acciones"]; // Función para manejar el scroll y mostrar tooltip

  var handleScroll = function handleScroll(event) {
    if (!tableRef.current || !scrollRef.current) return;
    var ths = tableRef.current.querySelectorAll('thead th');
    if (!ths.length) return;
    var scrollLeft = scrollRef.current.scrollLeft;
    var clientWidth = scrollRef.current.clientWidth; // Encontrar la columna que está en el centro del viewport

    var viewportCenter = scrollLeft + clientWidth / 2;
    var closestColumn = 0;
    var minDistance = Infinity;
    ths.forEach(function (th, idx) {
      var thElement = th;
      var thLeft = thElement.offsetLeft;
      var thWidth = thElement.offsetWidth;
      var thCenter = thLeft + thWidth / 2;
      var distance = Math.abs(thCenter - viewportCenter);

      if (distance < minDistance) {
        minDistance = distance;
        closestColumn = idx;
      }
    }); // Posicionar el tooltip justo encima de la barra de scroll

    var scrollRect = scrollRef.current.getBoundingClientRect();
    var scrollbarY = scrollRect.bottom - 20; // 20px arriba de la barra
    // Calcular posición X basada en la columna más cercana al centro

    var thElement = ths[closestColumn];
    var thLeft = thElement.offsetLeft;
    var thWidth = thElement.offsetWidth;
    var thCenter = thLeft + thWidth / 2; // Ajustar la posición X para que esté centrada en la columna

    var adjustedX = scrollRect.left + (thCenter - scrollLeft); // Solo mostrar tooltip si hay scroll horizontal

    if (scrollLeft > 0 || scrollRef.current.scrollWidth > scrollRef.current.clientWidth) {
      setScrollTooltip({
        show: true,
        text: "Columna: ".concat(columnNames[closestColumn]),
        x: adjustedX,
        y: scrollbarY
      });
    }
  }; // Función para ocultar tooltip cuando se suelta el scroll


  var handleScrollEnd = function handleScrollEnd() {
    setScrollTooltip(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        show: false
      });
    });
  }; // Función para manejar cuando se suelta el mouse o el touch


  var handleMouseUp = function handleMouseUp() {
    handleScrollEnd();
  };

  var handleTouchEnd = function handleTouchEnd() {
    handleScrollEnd();
  }; // Función para manejar cuando se mueve el mouse sobre la barra de scroll


  var handleMouseMove = function handleMouseMove(event) {
    if (!scrollRef.current) return;
    var rect = scrollRef.current.getBoundingClientRect();
    var mouseY = event.clientY; // Solo mostrar tooltip si el mouse está cerca de la barra de scroll

    if (mouseY >= rect.bottom - 30) {
      handleScroll(event);
    } else {
      handleScrollEnd();
    }
  };
  /* poliza.status PUEDEN SER => "BORRADOR" , "VIGENTE", "NO VIGENTE"
  poliza.sub_status PUEDEN SER => "NUEVA", "POR RENOVAR" ..... */


  var listPolizaRenewals = function listPolizaRenewals() {
    return polizaRenewals.map(function (polizaRenewal) {
      var _polizaRenewal$poliza, _polizaRenewal$poliza2, _polizaRenewal$poliza3, _polizaRenewal$poliza4, _polizaRenewal$poliza5, _polizaRenewal$poliza6, _polizaRenewal$poliza7, _polizaRenewal$poliza8;

      return /*#__PURE__*/React.createElement("tr", {
        key: polizaRenewal.id
      }, /*#__PURE__*/React.createElement("th", {
        scope: "row"
      }, /*#__PURE__*/React.createElement("a", {
        href: "/admin/polizas/".concat(polizaRenewal.poliza_id)
      }, polizaRenewal.poliza_id)), /*#__PURE__*/React.createElement("td", {
        style: {
          padding: "4px 8px",
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: "#polizaRenewalModal",
        "data-toggle": "modal",
        "data-target": "#polizaRenewalModal",
        onClick: function onClick() {
          onSelectedPolizaRenewal && onSelectedPolizaRenewal(polizaRenewal);
        },
        style: {
          fontSize: "13px",
          fontWeight: "600",
          color: "#2596be",
          textDecoration: "none",
          letterSpacing: "0.5px"
        },
        title: "Ver detalles de la renovaci\xF3n"
      }, polizaRenewal.poliza.code ? polizaRenewal.poliza.code : "Ver")), /*#__PURE__*/React.createElement("td", {
        title: polizaRenewal.aasm
      }, colorStatus(polizaRenewal.status_name), " ", polizaRenewal.status_name), /*#__PURE__*/React.createElement("td", null, colorCondition(polizaRenewal.condition), " ", polizaRenewal.condition ? function () {
        switch (polizaRenewal.condition) {
          case "same_conditions":
            return "Iguales condiciones";

          case "change_conditions":
            return "Cambio condiciones";

          case "without_conditions":
            return "Sin condiciones";

          case "extension":
            return "Prorroga";

          case "client_rejects_renewal":
            return "No renueva cliente";

          case "company_rejects_renewal":
            return "No renueva Compañía";

          default:
            return polizaRenewal.condition;
        }
      }() : "-"), /*#__PURE__*/React.createElement("td", null, polizaRenewal.poliza.company ? polizaRenewal.poliza.company.name : "-"), /*#__PURE__*/React.createElement("td", null, polizaRenewal.poliza.asegurado ? "".concat(fullName(polizaRenewal.poliza.asegurado), " ").concat(formatRut(polizaRenewal.poliza.asegurado.rut || "")) : "-"), /*#__PURE__*/React.createElement("td", null, (_polizaRenewal$poliza = polizaRenewal.poliza) !== null && _polizaRenewal$poliza !== void 0 && _polizaRenewal$poliza.item_asegurado ? polizaRenewal.poliza.materia_asegurada_formatted : "-"), /*#__PURE__*/React.createElement("td", null, polizaRenewal.poliza.start_date ? moment(polizaRenewal.poliza.start_date).format("DD-MM-YYYY") : "-"), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("b", null, polizaRenewal.poliza.finish_date ? moment(polizaRenewal.poliza.finish_date).format("DD-MM-YYYY") : "-")), /*#__PURE__*/React.createElement("td", null, (_polizaRenewal$poliza2 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza2 !== void 0 && _polizaRenewal$poliza2.ramo ? polizaRenewal.poliza.ramo : "-"), /*#__PURE__*/React.createElement("td", null, (_polizaRenewal$poliza3 = polizaRenewal.poliza) === null || _polizaRenewal$poliza3 === void 0 ? void 0 : _polizaRenewal$poliza3.currency, " ", (_polizaRenewal$poliza4 = polizaRenewal.poliza) !== null && _polizaRenewal$poliza4 !== void 0 && (_polizaRenewal$poliza5 = _polizaRenewal$poliza4.commission) !== null && _polizaRenewal$poliza5 !== void 0 && _polizaRenewal$poliza5.net_bonus ? (_polizaRenewal$poliza6 = polizaRenewal.poliza) === null || _polizaRenewal$poliza6 === void 0 ? void 0 : (_polizaRenewal$poliza7 = _polizaRenewal$poliza6.commission) === null || _polizaRenewal$poliza7 === void 0 ? void 0 : _polizaRenewal$poliza7.net_bonus : "-"), /*#__PURE__*/React.createElement("td", null, (_polizaRenewal$poliza8 = polizaRenewal.poliza) === null || _polizaRenewal$poliza8 === void 0 ? void 0 : _polizaRenewal$poliza8.currency, " ", polizaRenewal.net_bonus ? polizaRenewal.net_bonus : "-"), /*#__PURE__*/React.createElement("td", {
        style: {
          textAlign: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          gap: "8px",
          justifyContent: "center",
          position: "relative"
        }
      }, /*#__PURE__*/React.createElement(TooltipButton, {
        href: "/admin/polizas/".concat(polizaRenewal.poliza_id),
        className: "btn btn-info btn-xs",
        tooltip: "Ver p\xF3liza",
        style: {
          padding: "4px 8px",
          fontSize: "11px"
        },
        target: "_blank"
      }, /*#__PURE__*/React.createElement(FaEye, null)), /*#__PURE__*/React.createElement(TooltipButton, {
        href: "/admin/poliza_renewals/".concat(polizaRenewal.id, "/edit"),
        className: "btn btn-primary btn-xs",
        tooltip: "Editar renovaci\xF3n",
        style: {
          padding: "4px 8px",
          fontSize: "11px"
        }
      }, /*#__PURE__*/React.createElement(FaEdit, null)))));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, !polizaRenewals || polizaRenewals.length <= 0 ? /*#__PURE__*/React.createElement("h3", null, "No se han encontrado p\xF3lizas a renovar.") : /*#__PURE__*/React.createElement("div", {
    className: "table-responsive",
    style: {
      overflowX: "auto",
      maxWidth: "100%",
      position: "relative"
    },
    ref: scrollRef,
    onScroll: handleScroll,
    onMouseUp: handleMouseUp,
    onTouchEnd: handleTouchEnd,
    onMouseMove: handleMouseMove
  }, /*#__PURE__*/React.createElement("table", {
    ref: tableRef,
    className: "table table-striped table-sm table-bordered cntListPoliza",
    "data-toggle": "table",
    style: {
      minWidth: "1470px"
    }
  }, /*#__PURE__*/React.createElement("thead", {
    className: "tableHeader"
  }, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Propuesta"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "N\xBA P\xF3liza"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Estado"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Condici\xF3n"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Compa\xF1\xEDa"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Asegurado"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Materia"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Inicio Vigencia"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Fin Vigencia"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Ramo"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Prima Neta"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Prima Renovaci\xF3n"), /*#__PURE__*/React.createElement("th", {
    scope: "col"
  }, "Acciones"))), /*#__PURE__*/React.createElement("tbody", {
    className: "tableBody"
  }, listPolizaRenewals())), scrollTooltip.show && /*#__PURE__*/React.createElement("div", {
    className: "scroll-tooltip",
    style: {
      left: scrollTooltip.x,
      top: scrollTooltip.y
    }
  }, scrollTooltip.text)));
};

export default ListPolizaRenewal;